import * as React from 'react';
import type { ServiceOrder } from 'contracts/service-orders';
import { api } from 'services';

export const useFetchServiceOrder = () => {
  const fetchServiceOrder = React.useCallback(async (serviceOrderId: string | number) => {
    const { data } = await api.get<ServiceOrder>(`/inventory/service-orders/${serviceOrderId}`);
    return data;
  }, []);

  return {
    fetchServiceOrder,
  };
};